import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownFull = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 5,
	viewBox: "0 0 10 5",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0 0L5 5.00012L10 0.000118256L0 0Z",
		fill: "currentColor"
	})
});
export default SvgArrowDownFull;
